<template>
  <div class="clip-board-component">
    <div :id="id"
         :style="itemStyle"
    >
      {{ showValue ? value : '' }}
    </div>
    <div class="copy-btn"
         data-clipboard-action="copy"
         :data-clipboard-target="`#${id}`"
         @click="handleCopy"
    >
      {{ copyHint }}
    </div>
  </div>
</template>

<script>
  import ClipboardJS from 'clipboard';

  export default {
    name: 'ClipBoard',
    props: {
      value: {
        type: String,
        required: true,
      },
      id: {
        type: String,
        default: 'text',
      },
      color: String,
      copyHint: {
        type: String,
        default: '复制',
      },
      showValue: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      itemStyle() {
        const result = {};
        result.color = this.color;
        return result;
      },
    },
    methods: {
      handleCopy() {
        const clipboard = new ClipboardJS('.copy-btn');
        clipboard.on('success', async (e) => {
          await this.$toast('内容已复制到剪切板');
          this.$emit('copy-success');
          e.clearSelection();
        });
        clipboard.on('error', async () => {
          await this.$toast('复制失败，请手动复制');
          this.$emit('copy-success');
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .clip-board-component {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }

  #text {
    color: @color-text-lighter;
    font-size: @font-size-base;
  }

  .copy-btn {
    margin-top: 2px;
    color: @color-link;
    font-size: @font-size-extra-small;
    margin-left: @size-small;
  }
</style>
